import React from 'react';
import { useModal } from '@ui-library/modal/index';
import Button from '@ui-library/button';
import { apiAuthCaller } from '@services/apiCaller';
import useStores from '@stores/useStores';
import { ReactComponent as Plus } from '@svg/plus.svg';
import { MetaData } from '@ui-library/dynamicSelect';
import CreateResourceModalForm from './CreateResourceModalForm';
import { IResourceConfig } from '../../cloudSourceResources';
// name:String, resourceId:String, role:String!, source:{options:{}}, sink:{options:{},table:{}}
export interface CreateResourceButtonProps {
  customResources: string[] | null;
  normalResources?: string[];
  sourceRole: string;
  sourceId?: string;
  metadata?: MetaData;
  onSuccess?: (resource: IResourceConfig) => void;
}
const CreateResourceButton = ({
  metadata,
  customResources,
  normalResources,
  sourceRole,
  onSuccess,
  sourceId,
}: CreateResourceButtonProps) => {
  const modal = useModal();
  const { userStore } = useStores();

  if (!customResources || customResources.length === 0) {
    return null;
  }
  return (
    <Button
      className="create_resource_button"
      size="small"
      onClick={() =>
        modal.show({
          footer: null,
          content: (
            <CreateResourceModalForm
              normalResources={normalResources}
              onSubmit={async (resource) => {
                let data = resource as IResourceConfig;
                if (sourceId) {
                  const response = await apiAuthCaller(userStore.token).post(
                    `/cloudSources/source/${sourceId}/resources`,
                    resource,
                  );
                  data = response.data.resource;
                }

                if (onSuccess) {
                  await onSuccess(data);
                }
                modal.close();
              }}
              resources={customResources}
              sourceRole={sourceRole}
              metadata={metadata!}
              onClose={() => modal.close()}
            />
          ),
        })
      }
    >
      <>
        <Plus>+</Plus>
        Add Resource
      </>
    </Button>
  );
};

export default CreateResourceButton;
